export const createSelectionOverlay = (range, containerRef, fieldId) => {
    if (!range || !containerRef.current) return null;

    const containerRect = containerRef.current.getBoundingClientRect();
    const allRects = Array.from(range.getClientRects());

    const initialFilteredRects = allRects.filter((rect) => {
        if (rect.width < 5 || rect.height < 5) return false;

        if (rect.height > 40) return false;

        return true;
    });

    const sortedRects = [...initialFilteredRects].sort((a, b) => a.top - b.top);

    const finalFilteredRects = sortedRects.filter((rectA, indexA) => {
        for (let i = indexA + 1; i < sortedRects.length; i++) {
            const rectB = sortedRects[i];
            if (rectB.top >= rectA.bottom) break;
            const isWrapper =
                rectA.top <= rectB.top &&
                rectA.bottom > rectB.bottom &&
                rectA.height > rectB.height;
            if (isWrapper) return false;
        }
        return true;
    });
    
    const rectsToUse =
        finalFilteredRects.length > 0
            ? finalFilteredRects
            : allRects.length > 0
            ? [allRects[0]]
            : [];

    const overlayContainer = document.createElement('div');
    overlayContainer.className = 'selection-overlay-container';
    overlayContainer.dataset.fieldId = fieldId;
    overlayContainer.style.position = 'absolute';
    overlayContainer.style.top = '0';
    overlayContainer.style.left = '0';
    overlayContainer.style.right = '0';
    overlayContainer.style.bottom = '0';
    overlayContainer.style.pointerEvents = 'none';
    overlayContainer.style.zIndex = '10';

    rectsToUse.forEach((rect) => {
        const overlay = document.createElement('div');
        overlay.className = 'selection-highlight';
        overlay.style.position = 'absolute';
        overlay.style.backgroundColor = 'rgba(48, 133, 235, 0.4)';
        overlay.style.top = `${rect.top - containerRect.top - 2}px`;
        overlay.style.left = `${rect.left - containerRect.left}px`;
        overlay.style.width = `${rect.width + 3}px`;
        overlay.style.height = `${rect.height + 4}px`;
        overlay.style.pointerEvents = 'none';

        overlayContainer.appendChild(overlay);
    });

    containerRef.current.style.position = 'relative';
    containerRef.current.appendChild(overlayContainer);

    return overlayContainer;
};

export const removeSelectionOverlay = (fieldId) => {
    const overlays = document.querySelectorAll(
        `.selection-overlay-container[data-field-id="${fieldId}"]`
    );
    overlays.forEach((overlay) => overlay.remove());
};

export const removeAllSelectionOverlays = () => {
    const allOverlays = document.querySelectorAll('.selection-overlay-container');
    allOverlays.forEach((overlay) => overlay.remove());
};

export const onOpenGenericLogFeedbackModal = () => {
    window.getSelection().removeAllRanges();
    removeAllSelectionOverlays();
};
